import {
  WS_KEY,
  readWorkspaceLocal,
  writeWorkspaceLocal,
  removeWorkspaceLocal,
} from "./workspaceStorage";

export function loadActiveCentralLinkedImportJob() {
  try {
    const raw = readWorkspaceLocal(WS_KEY.CENTRAL_LINKED_IMPORT_ACTIVE_JOB);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.jobId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveActiveCentralLinkedImportJob({
  jobId,
  sourceProjectId,
  startedAt,
  phase,
}) {
  if (!jobId) return;
  const prev = loadActiveCentralLinkedImportJob();
  writeWorkspaceLocal(
    WS_KEY.CENTRAL_LINKED_IMPORT_ACTIVE_JOB,
    JSON.stringify({
      jobId: String(jobId),
      sourceProjectId: sourceProjectId ?? prev?.sourceProjectId ?? null,
      startedAt: startedAt || prev?.startedAt || new Date().toISOString(),
      phase: phase ?? prev?.phase ?? "running",
    })
  );
}

export function clearActiveCentralLinkedImportJob() {
  removeWorkspaceLocal(WS_KEY.CENTRAL_LINKED_IMPORT_ACTIVE_JOB);
}
